import React, { createContext, useContext, useState, useEffect } from 'react';
import { toast } from 'sonner';
import api from '../utils/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('briefcase_token'));
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('briefcase_user') || 'null'));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (token) {
      localStorage.setItem('briefcase_token', token);
    } else {
      localStorage.removeItem('briefcase_token');
    }
  }, [token]);

  useEffect(() => {
    if (user) {
      localStorage.setItem('briefcase_user', JSON.stringify(user));
    } else {
      localStorage.removeItem('briefcase_user');
    }
  }, [user]);

  const signup = async (email, password, orgName, fullName) => {
    setLoading(true);
    try {
      const response = await api.post('/auth/signup', {
        email,
        password,
        org_name: orgName,
        full_name: fullName
      });
      setToken(response.data.token);
      setUser(response.data.user);
      toast.success('Account created successfully!');
      return true;
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Signup failed');
      return false;
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    setLoading(true);
    try {
      const response = await api.post('/auth/login', { email, password });
      setToken(response.data.token);
      setUser(response.data.user);
      toast.success('Logged in successfully!');
      return true;
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    toast.info('Logged out');
  };

  return (
    <AuthContext.Provider value={{ token, user, loading, signup, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};